import {AssetsQaRequestParams} from "../../infrastructure/models/params/assets-qa-request-params";

export class ArrowChevronRequestParams extends AssetsQaRequestParams {
  constructor(width: Number, height: Number, direction: String) {
    super(width, height);

    this.resourceName = this.resourceName + `/Chevron${direction}`;
  }

}
